import { render, staticRenderFns } from "./JUpload.vue?vue&type=template&id=3f0040d2&scoped=true&"
import script from "./JUpload.vue?vue&type=script&lang=js&"
export * from "./JUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0040d2",
  null
  
)

export default component.exports